/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type QuartzTriggerState = 'EXECUTING' | 'SUCCEEDED' | 'FAILED';

export const QuartzTriggerState = {

    EXECUTING: 'EXECUTING' as QuartzTriggerState,

    SUCCEEDED: 'SUCCEEDED' as QuartzTriggerState,

    FAILED: 'FAILED' as QuartzTriggerState
};

